import {setAccessToken, removeAccessToken} from "@/storage/token";
import { welcome } from '@/utils/util'
import { encryptPassword } from '@/utils/util'
import request from '@/utils/request'

const user = {
  state: {
    nickname: '',
    welcome: '',
    avatar: '',
    info: {}
  },

  mutations: {
    SET_NICKNAME: (state, { nickname, welcome }) => {
      state.nickname = nickname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    // 清除用户身份信息，重置所有用户相关状态
    CLEAR_USER: (state) => {
      state.nickname = ''
      state.welcome = ''
      state.avatar = ''
      state.info = {}
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      const timestamp = Date.parse(new Date())
      userInfo.password = encryptPassword(userInfo.password, { timestamp })
      userInfo.timestamp = timestamp
      return new Promise((resolve, reject) => {
        request({
          url: "/auth/login",
          method: 'post',
          data: userInfo
        })
        .then(response => {
          if (response.code !== "success") {
            reject(response)
            return
          }
          const result = response.data
          setAccessToken(result.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        // 请求后端获取用户信息 /api/user/info
        request({
          url: "/user/my_info",
          method: 'get'
        })
        .then(response => {
          const result = response.data
          commit('SET_NICKNAME', { nickname: result.nickname, welcome: welcome() })
          commit('SET_AVATAR', result.avatar)
          commit('SET_INFO', result)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        request({
          url: "/auth/logout",
          method: 'post'
        })
        .then(() => {
          resolve()
        }).catch(() => {
          resolve()
        }).finally(() => {
          commit('CLEAR_USER')
          removeAccessToken()
        })
      })
    }

  }
}

export default user
